export default {
  state: {
    captchaNumbers: "",
    captchaInput: "",
  },

  getters: {
    getCaptchaNumbers(state) {
      return state.captchaNumbers;
    },

    getCaptchaInput(state) {
      return state.captchaInput;
    },
  },

  mutations: {
    setCaptchaNumbers(state) {
      const numbers = [];

      for (let index = 0; index < 4; index++) {
        numbers.push(String(Math.floor(Math.random() * 9)));
      }

      state.captchaNumbers = numbers;
    },

    setCaptchaInputInVoid(state) {
      state.captchaInput = "";
    },
  },

  actions: {
    changeCaptchaNumbers(context) {
      context.commit("setCaptchaNumbers");
    },

    changeCaptchaInput(context) {
      context.commit("setCaptchaInputInVoid");
    },
  },
};
